import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ObjetoListadoDatosDocsSubidosPrinc } from 'src/app/models/ObjetoListadoDatosDocsSubidosPrinc';
import { StatsService } from '../../../../core/services/stats.service';

@Component({
  selector: 'app-listado-datos-docs-subidos-princ',
  templateUrl: './listado-datos-docs-subidos-princ.component.html',
  styleUrls: ['./listado-datos-docs-subidos-princ.component.scss']
})
export class ListadoDatosDocsSubidosPrincComponent implements OnInit {

  filtro: FormGroup;
  HoyMoment = moment();
  formularioCompletado: boolean = false;
  //Carga de resultados...
  loading: boolean = false;
  loadingCarga: boolean = false;
  mostrarError: boolean = false;
  cargandoResultados: boolean = false;
  datos: ObjetoListadoDatosDocsSubidosPrinc[] = [];
  ordenesListado = [
    {
      id: 0,
      value: 'Fecha de subida'
    },
    {
      id: 1,
      value: 'ID de documento'
    },
    {
      id: 2,
      value: 'Tiempo en procesar'
    },
    {
      id: 3,
      value: 'Tiempo laborable en procesar'
    }
  ];
  opcionesTiemposMax = [
    {
      id: 0,
      value: 'Todos'
    },
    {
      id: 1,
      value: 'Menor o igual a 12 horas'
    },
    {
      id: 2,
      value: 'Mayor o igual a 24 horas'
    }
  ];
  totalDocumentos: number = 0;
  mediaTiempoProceso: string = "";

  constructor(
    private toastr: ToastrService,
    private fb: FormBuilder,
    private statsService: StatsService,
  ) {

    moment.locale('es');
    this.HoyMoment = moment();

    this.filtro = this.fb.group({
      principal: ['', [Validators.required]], //Campo Obligatorio para búsqueda
      secundario: [''],
      fechaInicial: [''],
      fechaFinal: [''],
      ordenListado: ['3'],
      tiemposMax: ['2']
    });
  }

  ngOnInit() {
  }

  onSubmit(formulario: FormGroup) {
    this.formularioCompletado = false;
    this.cargandoResultados = true;

    //console.log("Mostrando datos del formulario: ");
    //console.log(formulario);

    if (formulario.status == "INVALID") {

      this.toastr.error('Es necesario introducir un principal para cargar datos');
      this.cargandoResultados = false;
      this.loading = false;
      this.mostrarError = true;
      return;
    }

    //Carga datos...
    this.loading = true;
    this.mostrarError = false;
    this.mostrarError = false;
    this.datos = [];

    var fechaIni = this.filtro.get('fechaInicial').value;
    var fechaFinal = this.filtro.get('fechaFinal').value;
    var secundario: string = 'vacio';

    if (this.filtro.get('secundario').value != '') {
      secundario = this.filtro.get('secundario').value;
      secundario.toUpperCase();
    }

    var principal: string = this.filtro.get('principal').value;
    principal.toUpperCase();

    this.statsService.ObtenerListadoDatosDocsSubidosPrinc(
      principal,
      secundario,
      (fechaIni != '') ? this.GetFechaInteger(fechaIni) : 0,
      (fechaFinal != '') ? this.GetFechaInteger(fechaFinal) : 0,
    ).subscribe(datos => {
      this.loading = false;
      this.datos = datos;

      //this.prueba();

      this.ajustesDatosTiempoProceso();
      this.ajustesDatosTiempoLaborable();
      this.filtrarYordenar();

      this.cargandoResultados = false;
      this.formularioCompletado = true;

    }, (error) => {
      console.log(error);
      this.loading = false;
      this.mostrarError = true;
      this.cargandoResultados = false;
      this.formularioCompletado = true;
    });
  }

  cambiarOrden(orden: any) {
    this.loading = true;
    this.formularioCompletado = false;
    this.cargandoResultados = true;

    //Orden de fecha Subida...
    if (orden == '0') {

      this.datos = this.datos.sort((n1, n2) => {
        if (n1.fechaSubida < n2.fechaSubida) {
          return 1;
        } else if (n1.fechaSubida > n2.fechaSubida) {
          return -1;
        } else if (n1.fechaSubida == n2.fechaSubida) {

          if (n1.horaSubida < n2.horaSubida) {
            return 1;
          } else if (n1.horaSubida > n2.horaSubida) {
            return -1;
          }
        }
        return 0;
      });
    }
    //Orden de ID documento...
    if (orden == '1') {

      this.datos = this.datos.sort((n1, n2) => {
        if (n1.idDocumento < n2.idDocumento) {
          return 1;
        } else if (n1.idDocumento > n2.idDocumento) {
          return -1;
        }
        return 0;
      });
    }
    //Orden de tiempo en procesar...
    if (orden == '2') {

      this.datos = this.datos.sort((n1, n2) => {

        if (n1.tiempoProcesarNum < n2.tiempoProcesarNum) {
          return 1;
        } else if (n1.tiempoProcesarNum > n2.tiempoProcesarNum) {
          return -1;
        }
        // else if(n1.tiempoProcesarNum == n2.tiempoProcesarNum){
        //   return 0;
        // }
        return 0;
      });
    }
    //Orden de tiempo laborable en procesar...
    if (orden == '3') {


      this.datos = this.datos.sort((n1, n2) => {

        if (n1.tiempoLabProcHORAS < n2.tiempoLabProcHORAS) {
          return 1;
        } else if (n1.tiempoLabProcHORAS > n2.tiempoLabProcHORAS) {
          return -1;
        } else if (n1.tiempoLabProcHORAS == n2.tiempoLabProcHORAS) {

          if (n1.tiempoLabProcMINUTOS < n2.tiempoLabProcMINUTOS) {
            return 1;
          } else if (n1.tiempoLabProcMINUTOS > n2.tiempoLabProcMINUTOS) {
            return -1;
          }
        }
        return 0;
      });
    }

    this.loading = false;
    this.cargandoResultados = false;
    this.formularioCompletado = true;
  }

  ajustesDatosTiempoProceso() {

    this.datos.forEach(element => {

      var horaSubida = element.horaSubida;
      var horaSubidaString = "";

      ////////////////////////////////////////////////////////////////////////
      //Para hora subida...
      if (horaSubida.toString().length == 1) {
        horaSubidaString = `00:00:${horaSubida.toString().padStart(2, "0")}`;
      }
      if (horaSubida.toString().length == 2) {
        horaSubidaString = `00:00:${horaSubida.toString().substring(0, 1).padStart(2, "0")}`;
      }
      if (horaSubida.toString().length == 3) {
        horaSubidaString = `00:${horaSubida.toString().substring(0, 1).padStart(2, "0")}:${horaSubida.toString().substring(1, 3).padStart(2, "0")}`;
      }
      if (horaSubida.toString().length == 4) {
        horaSubidaString = `00:${horaSubida.toString().substring(0, 2).padStart(2, "0")}:${horaSubida.toString().substring(2, 4).padStart(2, "0")}`;
      }
      if (horaSubida.toString().length == 5) {
        horaSubidaString = `${horaSubida.toString().substring(0, 1).padStart(2, "0")}:${horaSubida.toString().substring(1, 3).padStart(2, "0")}:${horaSubida.toString().substring(3, 5).padStart(2, "0")}`;
      }
      if (horaSubida.toString().length == 6) {
        horaSubidaString = `${horaSubida.toString().substring(0, 2).padStart(2, "0")}:${horaSubida.toString().substring(2, 4).padStart(2, "0")}:${horaSubida.toString().substring(4, 6).padStart(2, "0")}`;
      }

      element.horaSubidaSTRING = horaSubidaString;

      ////////////////////////////////////////////////////////////////////////
      //Para hora procesado...
      var horaProcesado = element.horaProcesado;
      var horaProcesadoString = "";
      var hora = horaProcesado / 60;
      var minutos = horaProcesado % 60;
      var horaSinDecimal = Math.trunc(hora);
      var minutosSinDecimal = Math.trunc(minutos);
      var cadenaHora: string = (horaSinDecimal < 10) ? "0" + horaSinDecimal.toString() : horaSinDecimal.toString();
      var minutoHora: string = (minutosSinDecimal < 10) ? "0" + minutosSinDecimal.toString() : minutosSinDecimal.toString();
      horaProcesadoString = `${cadenaHora}:${minutoHora}:00`;

      element.horaProcesadoSTRING = horaProcesadoString;

      ////////////////////////////////////////////////////////////////////////
      //Rellenado 'Tiempo en procesar'...

      let dateIni = element.fechaSubida.toString();
      let anoIni = dateIni.substr(0, 4);
      let mesIni = dateIni.substr(4, 2);
      let diaIni = dateIni.substr(6, 2);
      var fechaIniFORMAT: string = `${diaIni}/${mesIni}/${anoIni}`;
      let dateFin = element.fechaProcesado.toString();
      let anoFin = dateFin.substr(0, 4);
      let mesFin = dateFin.substr(4, 2);
      let diaFin = dateFin.substr(6, 2);
      var fechaFinFORMAT: string = `${diaFin}/${mesFin}/${anoFin}`;

      moment.locale('es');
      var momentoSubida = moment(fechaIniFORMAT + " " + horaSubidaString, "DD/MM/YYYY HH:mm:ss");
      var momentoProcesado = moment(fechaFinFORMAT + " " + horaProcesadoString, "DD/MM/YYYY HH:mm:ss");
      var duration = moment.duration(momentoProcesado.diff(momentoSubida));
      var durationDias = duration.days();
      var durationHoras = duration.hours();
      var durationMinutos = duration.minutes();

      var cadenafINAL = "";
      cadenafINAL = ((durationDias < 10) ? ("0" + durationDias + "d, ") : durationDias + "d, ") +
        ((durationHoras < 10) ? ("0" + durationHoras + "h, ") : durationHoras + "h, ") +
        ((durationMinutos < 10) ? ("0" + durationMinutos + "m") : durationMinutos + "m");
      element.tiempoEnProcesar = cadenafINAL;
      var stringTiempoNum: string = ((durationDias < 10) ? ("0" + durationDias.toString()) : durationDias.toString()) +
        ((durationHoras < 10) ? ("0" + durationHoras.toString()) : durationHoras.toString()) +
        ((durationMinutos < 10) ? ("0" + durationMinutos.toString()) : durationMinutos.toString());
      element.tiempoProcesarNum = parseInt(stringTiempoNum);
    });
  }

  ajustesDatosTiempoLaborable() {

    this.datos.forEach(element => {

      var horaProcesado = element.horaProcesado;
      var hora = horaProcesado / 60;
      var minutos = horaProcesado % 60;
      var horaSinDecimal = Math.trunc(hora);
      var minutosSinDecimal = Math.trunc(minutos);
      var cadenaHora: string = (horaSinDecimal < 10) ? "0" + horaSinDecimal.toString() : horaSinDecimal.toString();
      var minutoHora: string = (minutosSinDecimal < 10) ? "0" + minutosSinDecimal.toString() : minutosSinDecimal.toString();
      var horaProcesadoString = `${cadenaHora}:${minutoHora}:00`;
      let dateIni = element.fechaSubida.toString();
      let anoIni = dateIni.substr(0, 4);
      let mesIni = dateIni.substr(4, 2);
      let diaIni = dateIni.substr(6, 2);
      var fechaIniFORMAT: string = `${diaIni}/${mesIni}/${anoIni}`;
      let dateFin = element.fechaProcesado.toString();
      let anoFin = dateFin.substr(0, 4);
      let mesFin = dateFin.substr(4, 2);
      let diaFin = dateFin.substr(6, 2);
      var fechaFinFORMAT: string = `${diaFin}/${mesFin}/${anoFin}`;
      moment.locale('es');
      var momentoSubida = moment(fechaIniFORMAT + " " + element.horaSubidaSTRING, "DD/MM/YYYY HH:mm:ss");
      var momentoProcesado = moment(fechaFinFORMAT + " " + element.horaProcesadoSTRING, "DD/MM/YYYY HH:mm:ss");

      var listadoDias: moment.Moment[] = this.recorrerFechas(momentoSubida, momentoProcesado);

      //SUBIDO Y PROCESADO FUERA DE DIAS LABORALES...
      if (listadoDias.length == 0) {
        element.tiempoLabProcHORAS = 0;
        element.tiempoLabProcMINUTOS = 0;
        element.tiempoLaborableEnProcesar = "Fuera de horario laboral";
        return;
      }

      if (listadoDias.length > 1) {

        var cuentaFinal: any = this.cuentaTiempos(listadoDias);
        var horasFinal: string = (cuentaFinal.horas != undefined) ? cuentaFinal.horas.toString() : "0";
        var minutosFinal: string = (cuentaFinal.minutos != undefined) ? cuentaFinal.minutos.toString() : "0";

        element.tiempoLabProcHORAS = parseInt(horasFinal);
        element.tiempoLabProcMINUTOS = parseInt(minutosFinal);
        element.tiempoLaborableEnProcesar = horasFinal + "h," + minutosFinal + "m";
        return;
      }
    });
  }

  recorrerFechas(ejemplosubida: moment.Moment, ejemploprocesado: moment.Moment): moment.Moment[] {

    var resultado: moment.Moment[] = [];

    var momentB = require('moment-business-days');
    var festivos: string[] = [
      "2022-01-01", "2022-01-06", "2022-04-15", "2022-08-15", "2022-10-12", "2022-11-01", "2022-12-06", "2022-12-08", "2022-12-26",
      "2023-01-06", "2023-04-07", "2023-05-01", "2023-08-15", "2023-10-12", "2023-11-01", "2023-12-06", "2023-12-08", "2023-12-25"
    ];
    momentB.updateLocale('es', {
      holidays: festivos,
      holidayFormat: 'YYYY-MM-DD',
      workingWeekdays: [1, 2, 3, 4, 5] //Lunes a Viernes
    });
    var formatSubida = momentB(ejemplosubida.format("DD/MM/YYYY HH:mm:ss"), "DD/MM/YYYY HH:mm:ss");
    var formatProcesado = momentB(ejemploprocesado.format("DD/MM/YYYY HH:mm:ss"), "DD/MM/YYYY HH:mm:ss");


    //SUBIDO Y PROCESADO DURANTE VACACIONES...
    if (formatSubida.isHoliday() == true && formatProcesado.isHoliday() == true) {
      //NO SON DIAS LABORALES... SE MARCA FACTURA COMO PROCESADA FUERA DE HORARIO LABORAL
      return resultado;
    }

    //Si se sube el documento durante un festivo, la subida se desplaza a las 00:00 del siguiente dia laboral disponible...
    if (formatSubida.isHoliday() == true) {

      var sustitucionSubida = ejemplosubida.clone();
      sustitucionSubida.set({ hour: 0, minute: 0, second: 0 });

      do {
        sustitucionSubida.add(1, "days");
      } while (momentB(sustitucionSubida.format("DD/MM/YYYY HH:mm:ss"), "DD/MM/YYYY HH:mm:ss").isHoliday() == true);

      ejemplosubida = sustitucionSubida;
      formatSubida = momentB(sustitucionSubida.format("DD/MM/YYYY HH:mm:ss"), "DD/MM/YYYY HH:mm:ss");
    }

    //Si se procesa el documento durante un festivo, el procesado se desplaza a las 23:59 del anterior dia laboral disponible...
    if (formatProcesado.isHoliday() == true) {

      var sustitucionProcesado = ejemploprocesado.clone();
      sustitucionProcesado.set({ hour: 23, minute: 59, second: 59 });

      do {
        sustitucionProcesado.subtract(1, "days");
      } while (momentB(sustitucionProcesado.format("DD/MM/YYYY HH:mm:ss"), "DD/MM/YYYY HH:mm:ss").isHoliday() == true);

      ejemploprocesado = sustitucionProcesado;
      formatProcesado = momentB(sustitucionProcesado.format("DD/MM/YYYY HH:mm:ss"), "DD/MM/YYYY HH:mm:ss");
    }

    //////////////////////////////////////////////////////////
    //////////////////////////////////////////////////////////

    //SUBIDA Y PROCESADA FIN DE SEMANA
    if (formatSubida.isBusinessDay() == false && formatProcesado.isBusinessDay() == false) {
      //NO SON DIAS LABORALES... SE MARCA FACTURA COMO PROCESADA FUERA DE HORARIO LABORAL
      return resultado;
    }

    //SUBIDA Y PROCESADA ENTRE SEMANA
    if (formatSubida.isBusinessDay() == true && formatProcesado.isBusinessDay() == true) {

      var duration = moment.duration(ejemploprocesado.diff(ejemplosubida));
      //Se añade dia de subida...
      resultado.push(ejemplosubida);

      if (duration.days() > 0) { //Diferencia de UN DIA O MAS entre momento de subida y procesado...

        var value = ejemplosubida.clone();
        value.set({ hour: 0, minute: 0, second: 0 });

        for (let index = 1; index < duration.days(); index++) {

          value.add(1, "days");
          resultado.push(value);
        }
      }

      resultado.push(ejemploprocesado);
      return resultado;
    }

    //SUBIDA ENTRE SEMANA Y PROCESADA FIN DE SEMANA
    if (formatSubida.isBusinessDay() == true && formatProcesado.isBusinessDay() == false) {

      //Se añade dia de subida...
      resultado.push(ejemplosubida);

      //Se mueve dia de procesado al viernes...
      var diaSemanaPROC = ejemploprocesado.day();
      var value = ejemploprocesado.clone();
      value.set({ hour: 23, minute: 59, second: 59 });

      if (diaSemanaPROC == 0) {
        value.subtract(2, "days");
      } else {
        value.subtract(1, "days");
      }

      //Se añade fecha de procesado final...
      resultado.push(value);
      return resultado;
    }

    //SUBIDA FIN DE SEMANA Y PROCESADA ENTRE SEMANA
    if (formatSubida.isBusinessDay() == false && formatProcesado.isBusinessDay() == true) {

      //Se mueve dia de subida al Lunes...
      var diaSemanaSUBIDA = ejemplosubida.day();
      var valueSUB = ejemplosubida.clone();
      valueSUB.set({ hour: 0, minute: 0, second: 0 });

      if (diaSemanaSUBIDA == 6) {
        valueSUB.add(2, "days");
      } else {
        valueSUB.add(1, "days");
      }

      resultado.push(valueSUB);

      var duration = moment.duration(ejemploprocesado.diff(valueSUB));

      if (duration.days() > 0) { //Diferencia de UN DIA O MAS entre momento de subida y procesado...

        var valueNEW2 = valueSUB.clone();

        for (let index = 1; index < duration.days(); index++) {

          valueNEW2.add(1, "days");
          valueNEW2.set({ hour: 0, minute: 0, second: 0 });
          resultado.push(valueNEW2);
        }
      }

      //Se aniade fecha de procesado...
      resultado.push(ejemploprocesado);
    }

    return resultado;
  }

  cuentaTiempos(listadoFechas: moment.Moment[]): any {

    var cuentaTotal = {
      horas: 0,
      minutos: 0
    };

    if (listadoFechas.length == 2) {

      var diferencia = moment.duration(listadoFechas[1].diff(listadoFechas[0]));
      var diferenciaDias = diferencia.days();
      var diferenciaHoras = diferencia.hours();
      var diferenciaMinutos = diferencia.minutes();

      cuentaTotal.horas = diferenciaHoras;
      if (diferenciaDias >= 1) {
        cuentaTotal.horas = cuentaTotal.horas + (diferenciaDias * 24);
      }
      cuentaTotal.minutos = diferenciaMinutos;
    }

    //Por ejemplo, subido un viernes y procesado el Lunes despues del fin de semana...
    if (listadoFechas.length > 2) {

      var horaSubida = listadoFechas[0].hour();
      var minutoSubida = listadoFechas[0].minute();

      var horasLaborales = 24 - horaSubida;
      var minutosLaborales = 0;

      if (minutoSubida != 0) {
        minutosLaborales = 60 - minutoSubida;
        horasLaborales = horasLaborales - 1;
      }

      cuentaTotal.horas = cuentaTotal.horas + horasLaborales;
      cuentaTotal.minutos = cuentaTotal.minutos + minutosLaborales;

      listadoFechas.shift();

      //Recorremos el resto de fechas...

      listadoFechas.forEach(date => {
        //Es un dia normal, contamos sus horas y minutos...
        if (date.day() != 6 && date.day() != 0) {
          cuentaTotal.horas = cuentaTotal.horas + date.hour();

          if (cuentaTotal.minutos + date.minute() >= 60) {

            cuentaTotal.horas = cuentaTotal.horas + 1;
            cuentaTotal.minutos = (cuentaTotal.minutos + date.minute()) - 60;
          } else {

            cuentaTotal.minutos = cuentaTotal.minutos + date.minute();
          }
        }
      });
    }

    return cuentaTotal;
  }

  festivosDays(dateFrom: number, dateTo: number): number {

    var festivos2022 = [20220101, 20220106, 20220415, 20220815, 20221012, 20221101, 20221206, 20221208, 20221226];
    var festivos2023 = [20230106, 20230407, 20230501, 20230815, 20231012, 20231101, 20231206, 20231208, 20231225];


    var from = moment(dateFrom, 'YYYYMMDD'), to = moment(dateTo, 'YYYYMMDD'), days = 0;


    while (!from.isSameOrAfter(to)) {
      var encontradoFestivo2022 = festivos2022.findIndex(d => d == parseInt(from.format('YYYYMMDD')));
      var encontradoFestivo2023 = festivos2023.findIndex(d => d == parseInt(from.format('YYYYMMDD')));

      // Si no es sabado ni domingo y si es festivo...
      if (from.isoWeekday() !== 6 && from.isoWeekday() !== 7 && (encontradoFestivo2022 != -1)) {
        days++;
      }
      if (from.isoWeekday() !== 6 && from.isoWeekday() !== 7 && (encontradoFestivo2023 != -1)) {
        days++;
      }
      from.add(1, 'days');
    }
    return days;
  }

  filtrarYordenar() {
    this.totalDocumentos = 0;
    this.mediaTiempoProceso = "";
    var nuevoListado: ObjetoListadoDatosDocsSubidosPrinc[] = [];
    var cuentaMediaHoras: number = 0;
    var cuentaMediaMinutos: number = 0;

    this.datos.forEach(element => {
      if (
        this.filtro.get('tiemposMax').value == '0' ||
        (this.filtro.get('tiemposMax').value == '1' && element.tiempoLabProcHORAS <= 12) ||
        (this.filtro.get('tiemposMax').value == '2' && element.tiempoLabProcHORAS >= 24)
      ) {
        nuevoListado.push(element);
      }
    });
    this.datos = nuevoListado;
    //console.log(this.datos);

    //medias y total...
    this.totalDocumentos = this.datos.length;
    this.datos.forEach(element => {

      cuentaMediaHoras = cuentaMediaHoras + element.tiempoLabProcHORAS;
      cuentaMediaMinutos = cuentaMediaMinutos + element.tiempoLabProcMINUTOS;
    });

    var resultadoMediaHoras = cuentaMediaHoras / this.totalDocumentos;
    var resultadoMediaMinutos = cuentaMediaMinutos / this.totalDocumentos;

    // console.log(Math.trunc(resultadoMediaHoras));
    // console.log(Math.trunc(resultadoMediaMinutos));

    this.mediaTiempoProceso = "" + Math.trunc(resultadoMediaHoras).toString() + " horas y " + Math.trunc(resultadoMediaMinutos).toString() + " minutos";

    this.cambiarOrden(this.filtro.get('ordenListado').value);
  }

  fechaChange($event, esLaFecha: number) {

    let fechaall: string = "";

    if (typeof ($event) === "string") {
      fechaall = $event;
    } else if (typeof ($event) === "number") {
      fechaall = $event.toString();
    } else if ($event.target != undefined && $event.target != null) {
      fechaall = $event.target.value;
    }

    let format = 'dd/mm/yy';

    let resultado = "";
    let fecha = "";

    if (fechaall.length == 10) {
      while (fechaall.indexOf("/") > -1) {
        fechaall = fechaall.replace("/", "");
      }
    }

    let diasMes = fechaall.substring(0, 2);
    let mesFecha = fechaall.substring(2, 4);

    if (fechaall) {
      if (fechaall.length > 8 || fechaall.length < 4 || fechaall.length == 7 || fechaall.length == 5) {

        this.toastr.error("Fecha incorrecta.");

      } else if (parseInt(diasMes) > 31 || parseInt(diasMes) < 1) {

        this.toastr.error("Fecha incorrecta.");

      } else if (parseInt(mesFecha) > 12 || parseInt(mesFecha) < 1) {

        this.toastr.error("Fecha incorrecta.");

      } else {

        if (fechaall.indexOf('/') >= 0 && fechaall != "") {

          let fechaArray = fechaall.split('/');

          let dia = fechaArray[0];
          dia = dia.length < 2 ? "0" + (dia) : dia;

          let mes = fechaArray[1];
          mes = mes.length < 2 ? "0" + (mes) : mes;

          let hoy = new Date;

          let anio = fechaArray[2];

          if (anio) {
            switch (anio.length) {
              case 4:
                anio = anio; break;
              case 2:
                anio = "20" + anio; break;
              default:
                anio = '';
            }

          } else { anio = hoy.getFullYear().toString(); }

          if (dia != '' && mes != '' && anio != '') {
            fecha = dia + mes + anio;
          }

        } else {
          fecha = fechaall;
        }

        if (this.isNumber(fecha)) {

          if (format === 'dd/mm') {

            switch (fecha.length) {
              case 8:
                resultado = fecha.substring(0, 2) + "/" + fecha.substring(2, 4);// + "/" + fecha.substring(4, 8);
                break;
              case 6:
                resultado = fecha.substring(0, 2) + "/" + fecha.substring(2, 4);// + "/" + anio;
                break;
              case 4:
                resultado = fecha.substring(0, 2) + "/" + fecha.substring(2, 4);// + "/" + new Date().getFullYear();
                break;
              default:
                resultado = fecha;
            }

          }
          else {

            switch (fecha.length) {
              case 8:
                resultado = fecha.substring(0, 2) + "/" + fecha.substring(2, 4) + "/" + fecha.substring(4, 8);
                break;
              case 6:
                var anio = fecha.substring(4, 6);

                if (parseInt(anio.substring(0, 1)) <= 9 && parseInt(anio.substring(0, 1)) >= 5) {
                  anio = "19" + anio;
                } else {
                  anio = "20" + anio;
                }
                resultado = fecha.substring(0, 2) + "/" + fecha.substring(2, 4) + "/" + anio;
                break;
              case 4:
                resultado = fecha.substring(0, 2) + "/" + fecha.substring(2, 4) + "/" + new Date().getFullYear();
                break;
              default:
                resultado = fecha;
            }

            moment.locale("es");
            var fechaValidacion = moment().format(resultado);

            if (!moment(fechaValidacion, 'DD-MM-YYYY').isValid()) {

              this.toastr.error('Fecha incorrecta.');

              resultado = "";

            } else {

              resultado = fechaValidacion;
            }
          }
        } else {
          this.toastr.error('Fecha incorrecta.');
          resultado = "";
        }

      }
    }

    if (esLaFecha == 1) { //Fecha Inicial...

      this.filtro.patchValue({
        fechaInicial: resultado
      });
    }

    if (esLaFecha == 2) { //Fecha Final...

      this.filtro.patchValue({
        fechaFinal: resultado
      });
    }
  }

  private isNumber(numero) {
    if (this.isDecimal(numero) || !isNaN(parseInt(numero))) {
      return true;
    }
    return false;
  }

  private isDecimal(numero) {
    if (typeof numero === 'undefined') {
      return false;
    } else {
      numero = Math.abs(numero);
    }

    var pattern = /^\d+(\.\d*)?$/;
    if (pattern.test(numero)) {
      return true;
    }
    else {
      return false;
    }
  }

  public GetFechaInteger(date: string): number {
    if (date == "" || date == undefined) {
      return 0;
    }

    if (date.length != 10) {
      return 0;
    }

    let dia = Number(date.substr(0, 2));
    let mes = Number(date.substr(3, 2));
    let ano = Number(date.substr(6, 4));

    if (Number.isNaN(dia) == true || dia == undefined || Number.isNaN(mes) == true || mes == undefined || Number.isNaN(ano) == true || ano == undefined) {
      return 0;
    }

    return ano * 10000 + mes * 100 + dia;
  }

  public convertThousandsFixed(number: any, digits) {

    if (typeof number === 'undefined') {
      number = 0.0;
    }

    if (this.isDecimal(number) === true) {
      number = parseFloat((Math.round(number * 100) / 100).toString()).toFixed(2);

      number = number.toString().replace('.', ',');
    }

    var value = number.toString().split('.').join('');

    var numbers = value.split(',');
    var enter = numbers[0];
    var new_number = '';

    var amount = enter.toString();
    amount = amount.split('').reverse();

    var output = '';

    for (var i = 0; i <= amount.length - 1; i++) {
      output = amount[i] + output;
      if ((i + 1) % 3 === 0 && (amount.length - 1) !== i) output = '.' + output;
    }

    if (digits !== '0') {

      if (numbers.length === 1) {
        if (numbers[0] === '') {
          new_number = output;
        } else {
          new_number = output + ',00';
        }
      } else {
        if (numbers[1] === '') {
          new_number = output + ',00';
        } else {
          if (numbers[1].substring(0, 2).length === 1) {
            new_number = output + ',' + numbers[1].substring(0, 1) + '0';
          } else {
            new_number = output + ',' + numbers[1].substring(0, digits);
          }
        }
      }
      if (new_number.substring(0, 1) === '-' && new_number.substring(1, 2) === '.') {
        new_number = new_number.replace('.', '');
      }
      if (new_number === '0,0000') {
        new_number = '0,00';
      }
    } else {
      new_number = output;
      if (numbers[1] !== undefined) {
        new_number = new_number + ',' + numbers[1];
      }
    }

    if (digits === '0') {
      numbers = new_number.split(',');
      if (Number(numbers[1]) === 0) {
        new_number = numbers[0];
      }
    }

    return new_number;
  }

  generarExcel() {

    var objeto: any = {
      principal: this.filtro.get("principal").value,
      secundario: this.filtro.get("secundario").value,
      fechaInicial: this.filtro.get("fechaInicial").value,
      fechaFinal: this.filtro.get("fechaFinal").value,
      totalDocs: this.totalDocumentos,
      mediaTiempoLaborable: this.mediaTiempoProceso,
      listado: this.datos
    };

    this.statsService.generarExcelDocProcSubidosPrinc(objeto).subscribe(resultado => {
      this.toastr.success("Excel generado. Descargando...");

      let dataType = resultado.type;
      let binaryData = [];
      binaryData.push(resultado);
      let downloadLink = document.createElement('a');
      downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: dataType }));
      downloadLink.setAttribute('download', "EstadisticaProcesadas");
      document.body.appendChild(downloadLink);
      downloadLink.click();

    }, error => {
      console.log(error);
      this.toastr.error("No se ha podido generar el documento excel");
    });

  }

  // pruebaLaborales() {

  //   var momentB = require('moment-business-days');
  //   var festivos: string[] = [
  //     "2022-01-01", "2022-01-06", "2022-04-15", "2022-08-15", "2022-10-12", "2022-11-01", "2022-12-06", "2022-12-08", "2022-12-26",
  //     "2023-01-06", "2023-04-07", "2023-05-01", "2023-08-15", "2023-10-12", "2023-11-01", "2023-12-06", "2023-12-08", "2023-12-25"
  //   ];
  //   momentB.updateLocale('es', {
  //     holidays: festivos,
  //     holidayFormat: 'YYYY-MM-DD',
  //     workingWeekdays: [1, 2, 3, 4, 5] //Lunes a Viernes
  //   });

  //   var ejemplosubida = moment("13/01/2023 10:27:56", "DD/MM/YYYY HH:mm:ss");
  //   var ejemploprocesado = moment("16/01/2023 15:50:00", "DD/MM/YYYY HH:mm:ss");
  //   var formatSubida = momentB(ejemplosubida.format("DD/MM/YYYY HH:mm:ss"), "DD/MM/YYYY HH:mm:ss");
  //   var formatProcesado = momentB(ejemploprocesado.format("DD/MM/YYYY HH:mm:ss"), "DD/MM/YYYY HH:mm:ss");

  //   var listadoDias: moment.Moment[] = this.recorrerFechas(ejemplosubida, ejemploprocesado);

  //   var cuentaFinal: any = this.cuentaTiempos(listadoDias);
  //   var horasFinal: string = (cuentaFinal.horas != undefined) ? cuentaFinal.horas.toString() : "0";
  //   var minutosFinal: string = (cuentaFinal.minutos != undefined) ? cuentaFinal.minutos.toString() : "0";
  // }

}
